<template>
	<v-dialog 
		v-model="dialog"
		:fullscreen="fullscreen"
		scrollable
		persistent
		content-class="rounded-xl"
	>
	<!-- :max-width="maxWidth" -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-tooltip bottom>
					<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
						<v-icon>mdi-view-gallery</v-icon>
					</v-btn>
					<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
				</v-tooltip>
			</slot>
		</template>

		<v-card>
			<!-- <v-toolbar flat dark color="primary" style="flex: 0 1 auto;"> -->
			<v-toolbar flat style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			
			<v-card-text>
				<v-img
					:src="image"
					aspect-ratio="2"
					contain
				></v-img>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn depressed :disabled="index==0" @click="index--">
					<v-icon left>mdi-arrow-left</v-icon>
				</v-btn>
				<v-btn depressed :disabled="index==items.length-1" @click="index++">
					<v-icon left>mdi-arrow-right</v-icon>
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>

export default {
	name: 'Gallery',
	components: {},
	data: () => ({
		dialog: false,
		fullscreen: false,
		loading: false,
		
		index: 0,
	}),
	props: {
		title:  		{ type: String, default: 'Галерея'},
		tooltip:  		{ type: String, default: 'Галерея'},
		icon:  			{ type: String, default: 'mdi-view-gallery'},
		/* maxWidth: 		{ type: [String,Number], default: 800 },*/
		selectedIndex: 		{ type: Number, default: 0 },
		items: 			{ type: Array, default: () => [] },
	},

	watch: {
		dialog(val) {
			if(val) {
				this.index = this.selectedIndex
			}
		}
	},
	
	computed: {
		image() {
			const file = this.items[this.index]
			return URL.createObjectURL(file)
		},
	},

	methods: {
		onCancel () {
			this.dialog = false
		},

		onOK () {
			this.dialog = false
			//this.$emit('ok', this.items)
		},
	},
}
</script>